<template>
    <div class="mt-2">
        <template v-if="loading">
            <v-progress-circular indeterminate
                                 color="primary"
                                 :size="40"
                                 width="2"></v-progress-circular>
        </template>
        <template v-else>
            <template v-if="atlases == 'error'">
                Atsiprašome, šiuo metu atlasai nepasiekiami...
            </template>
            <template v-else>
                <v-data-table :headers="headers"
                              :items="atlases"
                              locale="lt"
                              :items-per-page="20">
                    <template v-slot:item.actions="{item}">
                        <v-icon v-if="item['shareType'] == 'Viešas'"
                                class="mr-2"
                                @click="preview(item)"
                                size="20"
                                title="Atlaso peržiūra">
                            mdi-note
                        </v-icon>
                    </template>
                </v-data-table>
            </template>
        </template>
    </div>
</template>

<script>
    import AdminHelper from "../helpers/AdminHelper";
    import AtlasHelper from "../helpers/AtlasHelper";

    export default {
        data: function () {
            var data = {
                loading: true,
                atlases: null,
                headers: this.getHeaders()
            };
            return data;
        },
        created() {
            this.getAdminList();
        },
        methods: {
            getAdminList: function () {
                this.loading = true;
                AdminHelper.getAdminAtlasList().then(function (atlases) {
                    atlases.forEach(function (atlases) {
                        atlases["atlasType"] = this.getTypePretty(atlases["atlasType"]);
                        atlases["shareType"] = this.getShareTypePretty(atlases["shareType"]);
                    }.bind(this));
                    this.loading = false;
                    this.atlases = atlases;
                }.bind(this), function () {
                    this.loading = false;
                    this.atlases = "error";
                }.bind(this));
            },
            getHeaders: function () {
                var headers = [{
                    text: "Atlaso ID",
                    value: "atlasID"
                }, {
                    text: "Pavadinimas",
                    value: "title"
                }, {
                    text: "Autorius",
                    value: "owner"
                }, {
                    text: "Atlaso tipas",
                    value: "atlasType"
                }, {
                    text: "Dalinimosi tipas",
                    value: "shareType"
                }, {
                    text: "Sukūrimo data",
                    value: "createDate"
                }, {
                    text: "Veiksmai",
                    value: "actions",
                    sortable: false
                }];
                return headers;
            },
            getTypePretty: function (type) {
                var atlasTypes = AtlasHelper.getAtlasTypes();
                var result = atlasTypes.find(x => x.key === type);
                return result.name;
            },
            getShareTypePretty: function (type) {
                var shareTypes = AtlasHelper.getSharingTypeItems();
                var result = shareTypes.find(x => x.key === type);
                return result.name;
            },
            preview: function (item) {
                window.open(this.$router.history.base + "/atlas/" + item.atlasID, "_blank");
            }
        }
    };
</script>

<style scoped>
    .v-data-table {
        max-width: 1000px;
    }

    .v-data-table >>> td {
        max-width: 164px;
    }
</style>